module.exports = __webpack_public_path__ + "static/media/IMG_1273.0a8f4ddf.jpg";